/* istanbul ignore file */
export enum CategoryEnum {
  FLIGHT_PAY_PAGE = "flights_pay_page",
  DP_PAYMENT = "dynpack_pay_page",
  DP_PRIME_FARES = "dynpack_prime_fares",
}

export enum ActionsEnum {
  PRIME = "prime",
  PRIME_WIDGET = "prime_widget",
  PRIME_LIGHT_BOX = "prime_lightbox",
  PRIME_SELECTION = "prime_selection",
  UNLOCKED = "unlocked",
}

enum LabelZEnum {
  FREE_TRIAL = "freetrial",
  EXPIRED = "expired",
}

enum SubscriptionPeriod {
  FREE_TRIAL = "free_trial",
}

enum LabelYEnum {
  PRIME = "prime",
  NOPRIME = "no-prime",
}

const predicatesY_ = {
  "prime-add": ({
    wasPrimeSelectedInResults,
    isUserLogged,
    wasPrimeSelectedInPrimePage,
  }): boolean =>
    wasPrimeSelectedInResults && !isUserLogged && wasPrimeSelectedInPrimePage,
  "prime-std": ({
    wasPrimeSelectedInResults,
    isUserLogged,
    wasPrimeSelectedInPrimePage,
  }): boolean =>
    wasPrimeSelectedInResults && !isUserLogged && !wasPrimeSelectedInPrimePage,
  "no-prime-add": ({
    wasPrimeSelectedInResults,
    isUserLogged,
    wasPrimeSelectedInPrimePage,
  }): boolean =>
    !wasPrimeSelectedInResults && !isUserLogged && wasPrimeSelectedInPrimePage,
  "no-prime-std": ({
    wasPrimeSelectedInResults,
    isUserLogged,
    wasPrimeSelectedInPrimePage,
  }): boolean =>
    !wasPrimeSelectedInResults && !isUserLogged && !wasPrimeSelectedInPrimePage,
  "prime-add-log": ({
    wasPrimeSelectedInResults,
    isUserLogged,
    wasPrimeSelectedInPrimePage,
  }): boolean =>
    wasPrimeSelectedInResults && isUserLogged && wasPrimeSelectedInPrimePage,
  "prime-std-log": ({
    wasPrimeSelectedInResults,
    isUserLogged,
    wasPrimeSelectedInPrimePage,
  }): boolean =>
    wasPrimeSelectedInResults && isUserLogged && !wasPrimeSelectedInPrimePage,
  "no-prime-add-log": ({
    wasPrimeSelectedInResults,
    isUserLogged,
    wasPrimeSelectedInPrimePage,
  }): boolean =>
    !wasPrimeSelectedInResults && isUserLogged && wasPrimeSelectedInPrimePage,
  "no-prime-std-log": ({
    wasPrimeSelectedInResults,
    isUserLogged,
    wasPrimeSelectedInPrimePage,
  }): boolean =>
    !wasPrimeSelectedInResults && isUserLogged && !wasPrimeSelectedInPrimePage,
};

const logLabel = ({ isUserLogged, label }): string =>
  isUserLogged ? `${label}-log` : label;

export const labelY = ({ wasPrimeSelectedInResults, isUserLogged }): string =>
  wasPrimeSelectedInResults
    ? logLabel({ isUserLogged, label: LabelYEnum.PRIME })
    : logLabel({ isUserLogged, label: LabelYEnum.NOPRIME });

const labelY_ = ({
  wasPrimeSelectedInResults,
  isUserLogged,
  wasPrimeSelectedInPrimePage,
}): string => {
  return (
    Object.entries(predicatesY_).find((pred) =>
      pred[1]({
        wasPrimeSelectedInResults,
        isUserLogged,
        wasPrimeSelectedInPrimePage,
      }),
    )?.[0] || ""
  );
};

const labelZ = (subscriptionPeriod: string): string =>
  subscriptionPeriod === SubscriptionPeriod.FREE_TRIAL
    ? LabelZEnum.FREE_TRIAL
    : LabelZEnum.EXPIRED;

export const trackingLabelsSubscriptionAddBox = {
  onClickKnowMore: ({
    wasPrimeSelectedInResults,
    isUserLogged,
    subscriptionPeriod,
    wasPrimeSelectedInPrimePage,
  }): string =>
    `know_more_widget_sce:${labelY_({
      wasPrimeSelectedInResults,
      isUserLogged,
      wasPrimeSelectedInPrimePage,
    })}_user:${labelZ(subscriptionPeriod)}_pag:dp-pay`,
};

export const trackingLabelsPrimePage = {
  onMoreInfoClick: ({
    wasPrimeSelectedInResults,
    isUserLogged,
    subscriptionPeriod,
  }): string =>
    `know_more_selection_sce:${labelY({
      wasPrimeSelectedInResults,
      isUserLogged,
    })}_user:${labelZ(subscriptionPeriod)}_pag:dp-fares`,
};
